import { useState, useEffect, useRef } from "react";
import {
  SocketTopics,
  PageTopics,
  MapTopics,
  MessageTopics,
  TwilioTopics,
  CLBSTopics,
  UserSearchTopics,
  IotTopics,
  UserTopics,
} from "../constants/enums";
import useSocketActions from "./socketActions";
import { useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import mqtt from "mqtt";
import { generateUUID } from "utils/appUtil";

export default () => {
  const [socketClient, setSocketClient] = useState<any>();
  const { requestIds } = useSelector((state: RootState) => state.dashboard);
  const [connectedClient, setConnectedClient] = useState<any>();
  const callbacks = useRef<any>({});

  const {
    handlePageResults,
    handleFocusMap,
    handleTextMessage,
    handlePageTyping,
    handleVideoJoinNotification,
    handleVideoEndedNotification,
    handleSaveVideoNotification,
    handleRecordingMediaResult,
    handleUser,
    handleSearchMessageResult,
    handleGetPlaces,
    handleGetTokenResult,
    handleConnectionResult,
    handleSearchInPageResult,
    handleIotAppend,
    handleCreatePageResult,
    handleMessageFocus,
    handleFindUsersToPage,
    handleSearchBds,
    handleUserBds,
    handleUpdatePageResult,
    handleVideoIotAppend,
    getProjectList,
    getAdminRolesList,
    handleGetLastIndex,
    handlePageFocus,
    handleCustomerData,
  } = useSocketActions();

  const socketConnect = () => {
    setSocketClient(
      mqtt.connect(process.env.REACT_APP_BASE_WS_URL, {
        clientId: generateUUID(),
        username: "live",
        password: "beamL1ve",
      })
    );
  };

  useEffect(() => {
    return () => {
      if (socketClient) {
        socketClient.end(undefined, undefined, () => {
          console.log("Disconnected");
        });
      }
    };
  }, []);

  useEffect(() => {
    if (socketClient) {
      socketClient.on("connect", () => {
        console.log("Connected");
        setConnectedClient(socketClient);
      });
      socketClient.on("error", (err) => {
        console.error("Connection error: ", err);
        socketClient.end();
      });
      socketClient.on("reconnect", () => {
        console.log("Reconnecting");
      });
      socketClient.on("disconnect", () => {
        console.log("Disconnecting");
      });
      socketClient.on("message", socketMessageReceivedListener);
    }
  }, [socketClient]);

  const publishToEvent = (
    event: SocketTopics,
    topic: string,
    data: IPublishWrapRequest | IPublishRequest,
    callback: any = () => { }
  ) => {
    if (socketClient) {
      socketClient.publish(topic, JSON.stringify(data), { qos: 1 }, (error) => {
        if (error) {
          console.warn("Publish failed", topic, error);
          callback({ status: false });
        } else {
          callback({ status: true });
        }
      });
    }
  };

  const subscribeToEvent = (
    event: SocketTopics,
    topic: string,
    callback: any = () => { }
  ) => {
    if (socketClient) {

      socketClient.subscribe(topic, { qos: 1 }, (error, granted) => {
        if (error) {
          console.log("Subscribe to topics error", topic, error);
          return;
        }
        /*
          A broker that refuses a topic does not report an error — it answers
          the SUBACK with qos 128 for that subscription and the connection
          carries on as if nothing happened. Without this check a denied
          subscription is indistinguishable from a quiet one, and the reader
          waits for samples the broker was never going to send.
        */
        const denied = (granted || []).filter((entry: any) => entry.qos === 128);
        if (denied.length) {
          console.warn("Subscribe refused by broker", topic, granted);
          return;
        }
        callbacks.current[topic] = callback;
      });
    }
  };

  const unSubscribeToEvent = (
    event: SocketTopics,
    topic: string,
    callback: any = () => { }
  ) => {
    if (socketClient) {
      socketClient.unsubscribe(topic, (error) => {
        if (error) {
          console.log("unSubsribed to topics error", error);
          return;
        }
      });
    }
  };

  const publishToEventUser = (
    event: SocketTopics,
    topic: string,
    data: IPublishRequest,
    subscribePath: string,
    callback: any = () => { }
  ) => { };
  const publishToEventServiceIdUser = (
    event: SocketTopics,
    topic: string,
    data: IPublishRequest,
    subscribePath: string,
    serviceId: string,
    callback: any = () => { }
  ) => { };
  const subscribeToEventUser = (
    event: SocketTopics,
    topic: string,
    callback: any = () => { }
  ) => { };

  const socketMessageReceivedListener = (topic: string, message: any) => {

    const payload = { topic, message: message.toString() };
    if (callbacks?.current?.[topic]) {
      callbacks?.current?.[topic](payload);
    }

    console.log('payload', payload);

    if (topic.includes(MapTopics.FocusMap)) {
      handleFocusMap(JSON.parse(payload.message));
    } else if (topic.includes(MapTopics.IotAppend)) {
      handleIotAppend(payload);
    } else if (topic.includes(MessageTopics.CreateMessageResult)) {
      handleTextMessage({ subscribeToEvent, publishToEvent }, payload);
    } else if (topic.includes(PageTopics.PageTyping)) {
      handlePageTyping(payload);
    } else if (topic.includes(TwilioTopics.VideoJoin)) {
      handleVideoJoinNotification(JSON.parse(payload.message).data);
    } else if (topic.includes(TwilioTopics.VideoEnd)) {
      handleVideoEndedNotification(JSON.parse(payload.message).data);
    } else if (topic.includes(TwilioTopics.SaveRecording)) {
      handleSaveVideoNotification(JSON.parse(payload.message).data);
    } else if (topic.includes(TwilioTopics.RecordingMediaResult)) {
      handleRecordingMediaResult(payload);
    } else if (topic.includes(PageTopics.FocusPage)) {
      handlePageFocus(payload);
    }
    else if (topic.includes(UserTopics.SearchInUser)) {
      getAdminRolesList(payload);
    } else if (topic.includes(UserTopics.User)) {
      handleUser({ subscribeToEvent, publishToEvent }, topic, payload);
    } else if (topic.includes(MessageTopics.SearchMessageResult)) {
      handleSearchMessageResult(payload);
    } else if (topic.includes(CLBSTopics.GetPlaces)) {
      handleGetPlaces(payload);
    } else if (topic.includes(TwilioTopics.GetTokenResult)) {
      handleGetTokenResult(payload);
    } else if (topic.includes(MessageTopics.ConnectionBDS)) {
      handleConnectionResult(payload);
    } else if (topic.includes(PageTopics.SearchInPageResult)) {
      handleSearchInPageResult(payload);
    } else if (topic.includes(PageTopics.SearchInPageResult)) {
      handleSearchInPageResult(payload);
    } else if (topic.includes(PageTopics.CreatePageResult)) {
      handleCreatePageResult({ subscribeToEvent, publishToEvent }, payload);
    } else if (topic.includes(PageTopics.UpdatePageResult)) {
      handleUpdatePageResult({ subscribeToEvent, publishToEvent }, payload);
    } else if (topic.includes(MessageTopics.FocusMessage)) {
      handleMessageFocus(payload);
    } else if (topic.includes(UserSearchTopics.FindUsersToPage)) {
      handleFindUsersToPage(payload);
    } else if (topic.includes(UserSearchTopics.AggregateBds)) {
      const pageRequestId = requestIds.page;
      const userRequestId = requestIds.user;
      const messageRequestId = requestIds.message;
      if (pageRequestId === JSON.parse(payload.message)?.id || JSON.parse(payload.message)?.id === PageTopics.FowardMessagePopup) {
        handlePageResults(JSON.parse(payload.message).response.data, JSON.parse(payload.message)?.id);
      } else if (userRequestId === JSON.parse(payload.message)?.id) {
        handleSearchBds(payload);
      }
      else if (messageRequestId === JSON.parse(payload.message)?.id) {
        handleSearchMessageResult(payload);
      }
    } else if (topic.includes(UserSearchTopics.SearchBds)) {
      handleUserBds(payload);
    } else if (topic.includes(PageTopics.GetProjectsResult)) {
      getProjectList(payload);
    } else if (topic.includes(IotTopics.Append)) {
      handleVideoIotAppend(payload);
    } else if (topic.includes(IotTopics.GetLastIndex)) {
      handleGetLastIndex(payload);
    } else if (topic.includes("custom-bds/aggregateCustom/reply")) {
      handleCustomerData(payload);
    }
  };

  return {
    socketClient: connectedClient,
    socketConnect,
    socketSubscribeToEvent: subscribeToEvent,
    socketUnSubscribeToEvent: unSubscribeToEvent,
    socketPublishToEvent: publishToEvent,
    publishToEventUser,
    publishToEventServiceIdUser,
    subscribeToEventUser,
  };
};
